import { useState } from "react";
import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import Tooltip from "@JohnLewisPartnership/jl-design-system/dist/components/tooltip/Tooltip";
import { ProductAccordionWithMonetateEvents } from "../../ProductAccordionWithMonetateEvents";
import { Attribute } from "@/types/prodcatBaseTypes";
import styles from "./ProductMeasurementsAccordion.module.scss";

type Props = {
  attributes: Attribute[];
  sellingProductType: string;
  open?: boolean;
};

function formatProductType(sellingProductType: string) {
  return sellingProductType
    .toLowerCase()
    .substring(sellingProductType.length - 1) === "s"
    ? sellingProductType
        .toLowerCase()
        .substring(0, sellingProductType.length - 1)
    : sellingProductType.toLowerCase();
}

export function ProductMeasurementsAccordionUI({
  attributes,
  sellingProductType,
  open,
}: Props) {
  const [isOpen, setIsOpen] = useState(open);
  const defaultHelpText = "Height, Width, Depth";

  if (attributes.length < 1) {
    return null;
  }

  const checkSizeText = [
    "Washing Machines",
    "Washer Dryers",
    "Dishwashers",
  ].includes(sellingProductType)
    ? "Check the dimensions to make sure your appliance can fit through doorways on delivery. When measuring the space where it will sit, remember to account for pipes."
    : `Check your new ${formatProductType(sellingProductType)} will fit in the space and there's enough room for our installers to move around.`;

  return (
    <ProductAccordionWithMonetateEvents name="Measurements" open={isOpen}>
      <Accordion
        data-testid="accordion:measurements"
        label="Measurements"
        animated={true}
        responsive
        open={open}
        onStateChange={(isOpen: boolean) => {
          setIsOpen(isOpen);
        }}
      >
        <div data-testid="product:measurements:accordion">
          <p>{checkSizeText}</p>
          <dl data-testid="product:measurements:list">
            {attributes.map((measurement) => (
              <div className={styles.measurement} key={measurement.key}>
                <dt
                  className={styles.measurementTitle}
                  data-testid="product:measurements:list:label"
                >
                  <span>{measurement.displayName}</span>
                  <ProductAttributeToolTip
                    helpText={measurement.helpText || defaultHelpText}
                    toolTipId={measurement.key}
                  />
                </dt>
                <dd
                  className={styles.measurementValue}
                  data-testid="product:measurements:list:value"
                >
                  {measurement.values[0]}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </Accordion>
    </ProductAccordionWithMonetateEvents>
  );
}

function ProductAttributeToolTip({
  helpText,
  toolTipId,
}: {
  helpText: string;
  toolTipId: string;
}) {
  return (
    <div
      data-testid="product:measurements:list:label:tooltip"
      className={styles.tooltipWrapper}
    >
      <Tooltip
        id={`tooltip-${toolTipId}`}
        icon
        anchor="right"
        verticalAnchor="top"
      >
        {helpText}
      </Tooltip>
    </div>
  );
}
